import { call, select } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectUserEntries, selectAvailableUserIds } from 'features/users/usersSlice';
import { UserId, UserEntries } from 'features/users/types';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';

export function* countVisibleUsersSaga(userIds: UserId[]) {
  // In breakout rooms, all users are visible regardless of role
  const isBreakoutRoom: boolean = yield select(selectIsBreakoutRoom);
  if (isBreakoutRoom) {
    const availableUserIds: UserId[] = yield select(selectAvailableUserIds);
    return availableUserIds.length;
  }

  // In main room, check role visibility for the provided userIds
  const userEntries: UserEntries = yield select(selectUserEntries);
  let visibleUsersCount = 0;

  for (const userId of userIds) {
    const user = userEntries[userId];
    if (user) {
      const canSeeRole: boolean = yield call(
        hasPermissionsSaga,
        PermissionTypes.seeRolesInParticipantsPanel,
        { targetRole: user.role }
      );

      if (canSeeRole) {
        visibleUsersCount += 1;
      }
    }
  }

  return visibleUsersCount;
}
